export var EHertzLinkNames;
(function (EHertzLinkNames) {
    // properties converted from Hertzlink DB table
    EHertzLinkNames["SequenceId"] = "sequenceID";
    EHertzLinkNames["EvalAgreement"] = "evalAgreement";
    EHertzLinkNames["ConsumerProduct"] = "consumerProduct";
    EHertzLinkNames["CdpCode"] = "cdpCode";
    EHertzLinkNames["JoinCdpCode"] = "joinCdpCode";
    EHertzLinkNames["RateCode"] = "rateCode";
    EHertzLinkNames["PromotionCoupon"] = "promotionCoupon";
    EHertzLinkNames["ImageName"] = "imageName";
    EHertzLinkNames["SourceCode"] = "sourceCode";
    EHertzLinkNames["Iata"] = "iata";
    EHertzLinkNames["CvNumber"] = "cvNumber";
    EHertzLinkNames["MinAge"] = "minAge";
    EHertzLinkNames["Hotel"] = "hotel";
    EHertzLinkNames["Travel"] = "travel";
    EHertzLinkNames["ConsumerLoyalty"] = "consumerLoyalty";
    EHertzLinkNames["Service"] = "service";
    EHertzLinkNames["LdwUsInd"] = "ldwInsuranceUS";
    EHertzLinkNames["LdwCaInd"] = "ldwInsuranceCA";
    EHertzLinkNames["LisUsInd"] = "lisInsuranceUS";
    EHertzLinkNames["LisCaInd"] = "lisCaliforniaInsuranceUS";
    EHertzLinkNames["PaipecUsInd"] = "paiPecInsuranceUS";
    EHertzLinkNames["PaipecCaInd"] = "paiPecInsuranceCA";
    EHertzLinkNames["LdwEmea"] = "ldwEmea";
    EHertzLinkNames["TpEmeaInd"] = "tpInsuranceEMEA";
    EHertzLinkNames["PaipiEmeaInd"] = "paiPiInsuranceEMEA";
    EHertzLinkNames["PaiNzInd"] = "paiInsuranceNZ";
    EHertzLinkNames["PecNzInd"] = "pecInsuranceNZ";
    EHertzLinkNames["AerNzInd"] = "aerInsuranceNZ";
    EHertzLinkNames["SplashPageUrl"] = "splashPageUrl";
    EHertzLinkNames["SoInclusiveExclusive"] = "specialOffersInclusiveExclusive";
    EHertzLinkNames["Air"] = "air";
    EHertzLinkNames["Rail"] = "rail";
    EHertzLinkNames["FeePaid"] = "feePaid";
    EHertzLinkNames["Pos"] = "pos";
    EHertzLinkNames["Language"] = "language";
    EHertzLinkNames["ParentContext"] = "parentContext";
    EHertzLinkNames["Neverlost"] = "neverLost";
    EHertzLinkNames["EmeaNeverlost"] = "emeaNeverLost";
    EHertzLinkNames["Sirius"] = "sirius";
    EHertzLinkNames["HandControls"] = "handControls";
    EHertzLinkNames["SmokingPref"] = "smokingPref";
    EHertzLinkNames["GoldEnabled"] = "goldEnabled";
    EHertzLinkNames["Hcc"] = "hcc";
    EHertzLinkNames["UsCar"] = "usCar";
    EHertzLinkNames["CaCar"] = "caCar";
    EHertzLinkNames["EmeaCar"] = "emeaCar";
    EHertzLinkNames["AuCar"] = "auCar";
    EHertzLinkNames["NzCar"] = "nzCar";
    EHertzLinkNames["ScEmeaInd"] = "scEmeaInd";
    EHertzLinkNames["AuInd"] = "auInd";
    EHertzLinkNames["ShowBusinessInfo"] = "showBusinessInfo";
    EHertzLinkNames["JoinNeverLost"] = "joinNeverLost";
    EHertzLinkNames["MemberContext"] = "memberContext";
    EHertzLinkNames["HomepageAdRestrictions"] = "homepageIsAdRestricted";
    EHertzLinkNames["TopNavFilename"] = "topNavFileName";
    EHertzLinkNames["Abta"] = "aBTA";
    EHertzLinkNames["Ta"] = "tA";
    EHertzLinkNames["Tadns"] = "tADNS";
    EHertzLinkNames["Posdns"] = "posDNS";
    EHertzLinkNames["MethodOfPaymentDisplay"] = "methodOfPaymentDisplay";
    EHertzLinkNames["DisplayJoinButton"] = "displayJoinButton";
    EHertzLinkNames["DisplayCompOrder"] = "displayCompOrder";
    EHertzLinkNames["DisplayFT"] = "displayFT";
    EHertzLinkNames["DisplayOtherLocationsLink"] = "displayOtherLocationsLink";
    EHertzLinkNames["DefaultPreferredAddress"] = "defaultPreferredAddress";
    EHertzLinkNames["CorporateCustomer"] = "corporateCustomer";
    EHertzLinkNames["CorporateCustomerEditable"] = "corporateCustomerEditable";
    EHertzLinkNames["DisplayCorpCustomerOptions"] = "displayAllCorporateCustomerOptions";
    EHertzLinkNames["DisplayCorpCdpOptions"] = "displayCorporateCDPOptions";
    EHertzLinkNames["DisplayDiscountCheckbox"] = "displayDiscountCheckbox";
    EHertzLinkNames["SuppressRmc"] = "suppressRMC";
    EHertzLinkNames["SuppressSo"] = "suppressSO";
    EHertzLinkNames["Fpo"] = "fpo";
    EHertzLinkNames["DisplayRemarks"] = "displayRemarks";
    EHertzLinkNames["MobileContext"] = "mobileContext";
    EHertzLinkNames["ReturnToPartner"] = "returnToPartner";
    EHertzLinkNames["SuppressExtras"] = "suppressExtras";
    // Other properties/params not from DB table
    EHertzLinkNames["ParamArrivingAirline"] = "arriving_airline";
    EHertzLinkNames["ParamFlightNum"] = "flight_num";
    EHertzLinkNames["ParamFt"] = "frequentTravelerCode";
    EHertzLinkNames["ParamFtNumber"] = "frequentTravelerNumber";
    EHertzLinkNames["ParamCellPhone"] = "cellPhone";
    EHertzLinkNames["ParamPhone"] = "phone";
    EHertzLinkNames["ParamLName"] = "lName";
    EHertzLinkNames["ParamFName"] = "fName";
    EHertzLinkNames["ParamUAddr1"] = "uAddr1";
    EHertzLinkNames["ParamUAddr2"] = "uAddr2";
    EHertzLinkNames["ParamUCity"] = "uCity";
    EHertzLinkNames["ParamUState"] = "uState";
    EHertzLinkNames["ParamUZip"] = "uZip";
    EHertzLinkNames["ParamAID"] = "AID";
    EHertzLinkNames["ParamAirRail"] = "airRail";
    EHertzLinkNames["ParamApplicantInputNumber"] = "applicantInputNumber";
    EHertzLinkNames["ParamBinRequired"] = "binRequired";
    EHertzLinkNames["ParamBoosterSeats"] = "boosterSeats";
    EHertzLinkNames["ParamC3Adid"] = "c3adid";
    EHertzLinkNames["ParamC3Apidt"] = "c3apidt";
    EHertzLinkNames["ParamChildSeats"] = "childSeats";
    EHertzLinkNames["ParamConcurId"] = "concurId";
    EHertzLinkNames["ParamConfNumber"] = "confNumber";
    EHertzLinkNames["ParamEfId"] = "ef_id";
    EHertzLinkNames["ParamEmail"] = "email";
    EHertzLinkNames["ParamFeeWaived"] = "feeWaived";
    EHertzLinkNames["ParamForwardProcessed"] = "forwardProcessed";
    EHertzLinkNames["ParamFpo"] = "fpo";
    EHertzLinkNames["ParamHotelTravelerCode"] = "hotelTravelerCode";
    EHertzLinkNames["ParamHotelTravelerNumber"] = "hotelTravelerNumber";
    EHertzLinkNames["ParamHzLkDeepLinkSuccess"] = "hzlkDeeplinkSuccess";
    EHertzLinkNames["ParamInfantSeats"] = "infantSeats";
    EHertzLinkNames["ParamIsConcur"] = "isConcur";
    EHertzLinkNames["ParamIsNotPartnerSpecific"] = "isNotPartnerSpecific";
    EHertzLinkNames["ParamKayakClickId"] = "kayakclickid";
    EHertzLinkNames["ParamLinkType"] = "linktype";
    EHertzLinkNames["ParamLoadTest"] = "loadTest";
    EHertzLinkNames["ParamMemberNumber"] = "memberNumber";
    EHertzLinkNames["ParamPageTo"] = "pageTo";
    EHertzLinkNames["ParamPID"] = "PID";
    EHertzLinkNames["ParamPromotionCoupon"] = "promotionCoupon";
    EHertzLinkNames["ParamRefererUrl"] = "refererUrl";
    EHertzLinkNames["ParamRequestToken"] = "requestToken";
    EHertzLinkNames["ParamResFpo"] = "resFpo";
    EHertzLinkNames["ParamResHandControls"] = "reshandControls";
    EHertzLinkNames["ParamResLdw"] = "resLdw";
    EHertzLinkNames["ParamResList"] = "resList";
    EHertzLinkNames["ParamResSirius"] = "resSirius";
    EHertzLinkNames["ParamResWidgetVersion"] = "resWidgetVersion";
    EHertzLinkNames["ParamSearchString"] = "searchString";
    EHertzLinkNames["ParamShortName"] = "shortName";
    EHertzLinkNames["ParamSID"] = "SID";
    EHertzLinkNames["ParamSkiEquip"] = "skiEquip";
    EHertzLinkNames["ParamSnowTires"] = "snowTires";
    EHertzLinkNames["ParamSplashText"] = "splashText";
    EHertzLinkNames["ParamSKwcid"] = "s_kwcid";
    EHertzLinkNames["ParamTarget"] = "target";
    EHertzLinkNames["ParamWheelChair"] = "wheelChair";
    EHertzLinkNames["ParamWifiHotspot"] = "wifiHotspot";
})(EHertzLinkNames || (EHertzLinkNames = {}));
